import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { Filter } from '../helpers/Filter';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { FlowOutputStepRunListItemInfo } from '../models/FlowOutputStepRunInfo';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { GetFlowOutputStepRunsRequest } from '../ServerApi/requests/GetFlowOutputStepRunsRequest';
import { GetMostRecentFlowOutputStepRunRequest } from '../ServerApi/requests/GetMostRecentFlowOutputStepRunRequest';
import { FilterFieldNames, ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { IOrderClause } from '../ServerApi/types/IOrderClause';
import { FieldValuesQuery } from './FieldValuesQuery';
import { IListResource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class FlowOutputStepRunsResource implements IListResource<FlowOutputStepRunListItemInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetFlowOutputStepRunsRequest, ServerApiMapper.flowOutputStepRuns);
  private fieldValuesFetcher = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<FlowOutputStepRunListItemInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getForFlow(flowId: string, orderClause: IOrderClause[]): ResourceQuery<FlowOutputStepRunListItemInfo> {
    const filterClause: ILeafFilterClause[] = [Filter.stringFieldEq(FilterFieldNames.flowId, flowId)];
    return this.all().withFiltersAndOrder(filterClause, orderClause);
  }

  public getMostRecentForFlow(flowId: string, completedRunsOnly: boolean): Promise<ReadonlyArray<FlowOutputStepRunListItemInfo>> {
    return WebHttpClient.sendRequest(new GetMostRecentFlowOutputStepRunRequest({ flowId, completedRunsOnly }))
      .then((result) => ServerApiMapper.flowOutputStepRuns(result));
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'flowOutputStepRun');
  }
}

export const FlowOutputStepRuns = new FlowOutputStepRunsResource();
